import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import { authUser } from "../../../utils/Functions/functions";
import UserEntryPopup from "../../../components/UserEntryPopup/UserEntryPopup";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function RegularShipments({ ...props }) {
  const [loggedIn, setLoggedIn] = React.useState(false);
  const authenticated = authUser(localStorage.getItem("JWT"));

  useEffect(() => {
    if (authenticated) {
      setLoggedIn(true);
    }
  }, [authenticated]);
  const handleLogin = () => {
    setLoggedIn(true);
    props.setLoggedIn(true);
  };
  return (
    <>
      <div className="StepContainer FormWidth">
        {loggedIn ? null : (
          <div className="FormSignInContainer FormWidth">
            <UserEntryPopup contact={props.contact} handleLogin={handleLogin} />
          </div>
        )}
        <div className="FormTitleContainer">
          <p className="FormQuestion">{i18n.t("stepone.label")}</p>
        </div>
        <div className="ContainerHorizontal MarginHorizontal">
          <Button
            onClick={() => {
              props.handleChange("regular", true);
              props.handleNext();
            }}
            className={
              props.order.regular === true
                ? "OldLace XL MarginHorizontal"
                : "TransparentWhite XL MarginHorizontal"
            }
          >
            {i18n.t("stepone.regular")}
          </Button>
          <Button
            onClick={() => {
              props.handleChange("regular", false);
              props.handleNext();
            }}
            className={
              props.order.regular === false
                ? "OldLace XL MarginHorizontal"
                : "TransparentWhite XL MarginHorizontal"
            }
          >
            {i18n.t("stepone.one")}
          </Button>
        </div>
      </div>
      <div className="NavigationContainer FormWidth">
        {loggedIn ? null : (
          <a href="https://www.skyu.hu/">
            <Button className="TransparentWhite Medium">
              {i18n.t("general.back")}
            </Button>
          </a>
        )}
      </div>
    </>
  );
}

export default withTranslation()(RegularShipments);
